export default __webpack_public_path__ + "static/media/new_mobileBackgroundImage.0d40e2c9.png";